
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"173","height":"173"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#2e7eb8","d":"M0 0h122.439v93.521H0z"}})])]),_c('path',{attrs:{"fill":"none","d":"M0 0h173v173H0z"}}),_c('g',{attrs:{"transform":"translate(25.194 40.083)","clip-path":"url(#a)","fill":"#2e7eb8"}},[_c('path',{attrs:{"d":"M74.383.791H58.267a8.6 8.6 0 00-8.813 8.356v75.222a8.6 8.6 0 008.813 8.358h16.116a8.6 8.6 0 008.814-8.358V9.147A8.6 8.6 0 0074.383.791m-19.142 18.83h8.188v54.56h-8.188zm0 60.347h22.164v4.4a2.827 2.827 0 01-3.022 2.572H58.267a2.829 2.829 0 01-3.026-2.572zm22.164-5.787h-8.188v-54.56h8.188zM55.241 9.147a2.829 2.829 0 013.026-2.57h16.116a2.826 2.826 0 013.022 2.57v4.685H55.241zM37.257 2.518L21.324.1a9.015 9.015 0 00-6.5 1.476 8.075 8.075 0 00-3.458 5.466L.09 81.421A8.6 8.6 0 007.553 91l15.934 2.415a9.425 9.425 0 001.392.1 8.52 8.52 0 008.572-7.047L44.717 12.1a8.6 8.6 0 00-7.46-9.582m.171 19.069l-8.174 53.945-8.1-1.227 8.175-53.947zM7.339 72.21l8.173-53.943 8.1 1.227-8.176 53.945zm21.05 9.045l-.66 4.352a2.372 2.372 0 01-1.108 1.634 3.313 3.313 0 01-2.269.454L8.418 85.282a2.833 2.833 0 01-2.607-3l.662-4.354zM39 11.234l-.7 4.631-21.916-3.32.7-4.631a2.811 2.811 0 013.377-2.091l15.931 2.416a3.28 3.28 0 012.033 1.106A2.379 2.379 0 0139 11.234M119.545.791a2.9 2.9 0 00-2.895 2.894V4.95H94.486V3.685a2.895 2.895 0 10-5.789 0v86.15a2.895 2.895 0 005.789 0v-.561h22.164v.561a2.895 2.895 0 005.789 0V3.685a2.9 2.9 0 00-2.894-2.894m-2.895 82.694h-3.484V10.736h3.484zm-9.273 0h-3.62V10.736h3.62zm-9.407 0h-3.484V10.736h3.484z"}})])])
          )
        }
      }
    